$giper_balls_offer $mol_page
	title @ \Публичная оферта
	body /
		<= Content $mol_text
			text @ \
				\# Публичная оферта
				\
				\## 1. Общие положения
				\
				\Настоящая публичная оферта (далее — «Оферта») представляет собой предложение Индивидуального предпринимателя (ИП), указанного в разделе «Реквизиты», заключить договор на оказание услуг по восстановлению жизней в игре Giper Balls (далее — «Услуга») на условиях, изложенных ниже.
				\
				\Акцептом настоящей Оферты является оплата Услуги Пользователем. С момента оплаты договор считается заключённым.
				\
				\## 2. Предмет договора
				\
				\2.1. Исполнитель обязуется предоставить Пользователю услугу по моментальному восстановлению игровых жизней в игре Giper Balls, а Пользователь обязуется оплатить Услугу.
				\
				\2.2. Услуга предоставляется в виде цифрового контента — восстановления игровых жизней в количестве, выбранном Пользователем при оформлении заказа.
				\
				\2.3. Восстановление жизней происходит автоматически сразу после успешной оплаты.
				\
				\## 3. Стоимость услуг
				\
				\3.1. Стоимость услуг указана на сайте и составляет:
				\- Восстановление 1 жизни — 200 руб.
				\- Восстановление 3 жизней — 400 руб.
				\- Восстановление 5 жизней — 500 руб.
				\
				\3.2. Оплата производится через платёжный сервис ЮKassa.
				\
				\## 4. Порядок оказания услуг
				\
				\4.1. Пользователь выбирает количество жизней для восстановления и производит оплату.
				\
				\4.2. После успешной оплаты жизни восстанавливаются автоматически в течение нескольких секунд.
				\
				\4.3. Если восстановление не произошло автоматически, Пользователь может обратиться в службу поддержки по адресу: cmyser.fast@mail.ru или через Telegram: @Dev_cmyser
				\
				\## 5. Возврат средств
				\
				\5.1. В соответствии с законодательством РФ, услуга по восстановлению игровых жизней является цифровым контентом, предоставляемым мгновенно после оплаты.
				\
				\5.2. Возврат средств не производится, если Услуга была оказана надлежащим образом (жизни были успешно восстановлены).
				\
				\5.3. В случае технического сбоя, когда оплата прошла, но жизни не восстановились, Пользователь имеет право на возврат средств или повторное предоставление Услуги. Для этого необходимо обратиться в службу поддержки в течение 14 дней с момента оплаты.
				\
				\## 6. Ответственность сторон
				\
				\6.1. Исполнитель не несёт ответственности за временную недоступность сервиса по причинам, не зависящим от Исполнителя (сбои интернет-провайдеров, технические работы и т.д.).
				\
				\6.2. Пользователь несёт ответственность за сохранность данных своего аккаунта и устройства.
				\
				\## 7. Реквизиты
				\
				\ИП: Индивидуальный предприниматель
				\ОГРНИП: 325350000056770
				\ИНН: 351400789430
				\
				\Email: cmyser.fast@mail.ru
				\Telegram: @Dev_cmyser
				\
				\## 8. Прочие условия
				\
				\8.1. Настоящая Оферта вступает в силу с момента её размещения на сайте и действует до момента её отзыва Исполнителем.
				\
				\8.2. Исполнитель оставляет за собой право вносить изменения в условия Оферты и/или отзывать Оферту в любой момент по своему усмотрению. Изменения вступают в силу с момента публикации новой версии Оферты на сайте.
				\
				\8.3. Все споры решаются путём переговоров. При невозможности урегулирования спора путём переговоров, спор подлежит разрешению в судебном порядке по месту нахождения Исполнителя.
